import { useState, useCallback } from 'react';

export default function useNotificationSystem() {
  const [notification, setNotification] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = useState(null);

  const showNotification = useCallback((message) => {
    if (!message) return;
    setNotification({ message });
  }, []);

  const closeNotification = useCallback(() => {
    setNotification(null);
  }, []);

  const showConfirm = useCallback((message) => {
    if (!message) {
      return Promise.resolve(false);
    }
    return new Promise((resolve) => {
      setConfirmationDialog({ message, resolve });
    });
  }, []);

  const handleConfirmResponse = useCallback((result) => {
    setConfirmationDialog((current) => {
      if (current?.resolve) {
        current.resolve(result);
      }
      return null;
    });
  }, []);

  return {
    notification,
    showNotification,
    closeNotification,
    confirmationDialog,
    showConfirm,
    handleConfirmResponse,
  };
}
